export default __webpack_public_path__ + "static/media/AvenirLTStd-Book.242cafa2.otf";